<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>评价系统->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="分类审核绑定设置" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="分类项目设置" name="second">
                <child2></child2>    
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import TeacherEvaluateType from './TeacherEvaluateType.vue'
    import TeacherEvaluateIndicatorsSet from './TeacherEvaluateIndicatorsSet.vue'

    export default {
        name:"TeacherEvaluateMain",
        components:{
            child1:TeacherEvaluateType,
            child2:TeacherEvaluateIndicatorsSet
        },
        data() {
            return {
                //默认第一个选项卡
                activeName: "first",
                title:"分类审核绑定设置"
            }
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="分类审核绑定设置";
                } else if(tab.name == "second") {
                    this.title="分类项目设置";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/teacher/TeacherEvaluateMain.vue